function NumberListErrorHandler(response = {}) {
  if (!(response && response.data)) return;
  const { data = {} } = response;
  const { error = {} } = data;
  const { httpCode: statusCode = "no-code", message = "", errorCode } = error;
  if (statusCode === 401) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "sessao-expirada",
          title: "Sessão expirada",
          message: "efetue o login novamente",
        },
      },
    };
  }else if (statusCode === 404) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "invite-not-found",
          title: "Ops, ocorreu um erro",
          message: "O convite não foi encontrado",
        },
      },
    };
  } else if (statusCode === 500) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO-500",
          title: "Ops",
          message: `Ocorreu um erro ao listar os seus números, tente novamente mais tarde! `,
          originalMessage: message,
          systemError: data,
        },
      },
    };
  } else if (statusCode === 422) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "cliente-cnpj",
          title: "Atenção",
          message: "Funcionalidade exclusiva para pessoa física. Caso você possua linhas em seu CNPJ acesse o Claro Empresas.",
          systemError: data,
        },
      },
    };
  } else {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO",
          title: "Ocorreu um erro inesperado!",
          message: "Verifique sua conexão com a internet e tente novamente",
          systemError: data,
        },
      },
    };
  }
}
export default NumberListErrorHandler;
